import { useTooltipStore } from '@/stores/tooltip'
import { syncTooltipLabel } from '@/helpers/accessibleName'
import { type Directive, type DirectiveBinding } from 'vue'

const bindings = new WeakMap<HTMLElement, DirectiveBinding>()
const handlers = new WeakMap<HTMLElement, { onEnter: () => void; onLeave: () => void; onClick: () => void }>()

export const DesTooltip: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const tip = useTooltipStore()
    bindings.set(el, binding)

    const onEnter = () => tip.show(el, bindings.get(el)!)
    const onLeave = () => tip.hide()
    const onClick = () => tip.hideImmediately()

    handlers.set(el, { onEnter, onLeave, onClick })
    el.addEventListener('mouseenter', onEnter)
    el.addEventListener('mouseleave', onLeave)
    el.addEventListener('click', onClick)
    syncTooltipLabel(el, binding.value)
  },

  updated(el: HTMLElement, binding: DirectiveBinding) {
    bindings.set(el, binding)
    syncTooltipLabel(el, binding.value)
  },

  unmounted(el: HTMLElement) {
    const tip = useTooltipStore()
    const h = handlers.get(el)

    if (h) {
      el.removeEventListener('mouseenter', h.onEnter)
      el.removeEventListener('mouseleave', h.onLeave)
      el.removeEventListener('click', h.onClick)
      handlers.delete(el)
    }

    bindings.delete(el)
    tip.hide()
  },
}
